import { useAuth } from '../../hooks/useAuth'

export function Header() {
  const { user, logout } = useAuth()

  const initials = user?.email
    ? user.email.slice(0, 2).toUpperCase()
    : 'AU'

  return (
    <header className="h-14 bg-white border-b border-gray-100 flex items-center justify-between px-6 flex-shrink-0">
      <div className="flex items-center gap-2 text-sm text-gray-500">
        <i className="ti ti-point-filled text-indigo-500" />
        <span>Online</span>
      </div>

      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2.5 pl-3 border-l border-gray-100">
          <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center">
            <span className="text-xs font-semibold text-indigo-700">{initials}</span>
          </div>
          <div className="hidden sm:block">
            <p className="text-sm font-medium text-gray-800 leading-none">{user?.email ?? '—'}</p>
            <p className="text-xs text-gray-400 mt-0.5">{user?.roleName ?? 'Admin'}</p>
          </div>
          <button
            onClick={logout}
            className="ml-2 p-1.5 rounded-lg text-gray-400 hover:text-red-500 hover:bg-red-50 transition-colors"
            title="Sign out"
          >
            <i className="ti ti-logout text-base" />
          </button>
        </div>
      </div>
    </header>
  )
}
